"use client"

import { Card, CardContent } from "@/components/ui/card"
import { useTranslations } from "next-intl"
import Image from "next/image"
import { Button } from "@/components/ui/button"
import { useStatistics } from "@/api/app/citizen/home/queries"
import Link from "next/link"

const Statistics = ({ locale }) => {

    const t = useTranslations()

    const { data } = useStatistics()

    return <Card className="self-center max-w-screen-lg bg-muted dark:bg-accent">
        <CardContent className="flex flex-col gap-4 p-0 pb-8 sm:gap-8 lg:gap-4">
            <div className="grid grid-cols-1 divide-y divide-border place-content-center sm:grid-cols-2 sm:divide-x sm:ml-[calc(theme(divideWidth.2)*-1)] sm:[clip-path:inset(0_0_0_theme(divideWidth.2))] lg:grid-cols-4 lg:divide-y-0 lg:divide-x-0">
                <div className="flex flex-col gap-4 px-4 py-8 sm:p-6 md:p-8 lg:p-6">
                    <div className="flex flex-row items-center gap-4">
                        <div className="relative flex items-center justify-center aspect-square w-[62px]">
                            <Image
                                src="/assets/svg/Home/people.svg"
                                alt="Illustration - People"
                                fill
                                className="object-contain"
                            />
                        </div>
                        <p className="text-lg font-semibold">{"3 181 510"}</p>
                    </div>
                    <p className="text-sm">{t("index.section_5.indicator_container_1.indicator_content")}</p>
                </div>
                <div className="flex flex-col gap-4 px-4 py-8 sm:p-6 md:p-8 lg:p-6">
                    <div className="flex flex-row items-center gap-4">
                        <div className="relative flex items-center justify-center aspect-square w-[62px]">
                            <Image
                                src="/assets/svg/Home/trash.svg"
                                alt="Illustration - People"
                                fill
                                className="object-contain"
                            />
                        </div>
                        <p className="text-lg font-semibold">{data.cities_signals_amount.toLocaleString(
                            locale
                        )}</p>
                    </div>
                    <p className="text-sm">{t("index.section_5.indicator_container_2.indicator_content")}</p>
                </div>
                <div className="flex flex-col gap-4 px-4 py-8 sm:p-6 md:p-8 lg:p-6">
                    <div className="flex flex-row items-center gap-4">
                        <div className="relative flex items-center justify-center aspect-square w-[62px]">
                            <Image
                                src="/assets/svg/Home/energy.svg"
                                alt="Illustration - People"
                                fill
                                className="object-contain"
                            />
                        </div>
                        <p className="text-lg font-semibold">{data.ambassadors_amount.toLocaleString(locale)}</p>
                    </div>
                    <p className="text-sm">{t("index.section_5.indicator_container_3.indicator_content")}</p>
                </div>
                <div className="flex flex-col gap-4 px-4 py-8 sm:p-6 md:p-8 lg:p-6">
                    <div className="flex flex-row items-center gap-4">
                        <div className="relative flex items-center justify-center aspect-square w-[62px]">
                            <Image
                                src="/assets/svg/Home/school.svg"
                                alt="Illustration - People"
                                fill
                                className="object-contain"
                            />
                        </div>
                        <p className="text-lg font-semibold">{"2015"}</p>
                    </div>
                    <p className="text-sm">{t("index.section_5.indicator_container_4.indicator_content")}</p>
                </div>
            </div>
            <Button variant="secondary" className="self-center" asChild>
                <Link href="/statistics">
                    {t("index.section_5.button")}
                </Link>
            </Button>
        </CardContent>
    </Card>
}

export default Statistics